<ng-content></ng-content>

<span *ngIf="defaultText && (!items.length)" class="vx-menu-default-text">
  {{defaultText}}
</span>
